export default "__VITE_ASSET__Bi0fjZdw__"